/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { getOrders, GetOrdersApiParameter } from "@eisinc/App/Services/OrderService";
import { ApiHandler, createHandlerChainRunner, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";
import { OrderCollectionModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<GetOrdersApiParameter, OrderCollectionModel>;

export const XRequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getOrders(props.apiParameter);
};

replaceInChain(chain, RequestDataFromApi, XRequestDataFromApi);
